export default {
  data() {
    return {
      topOffect: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let top = Math.floor(
        document.documentElement.scrollTop || document.body.scrollTop
      );
      this.topOffect = top;
    }
  }
};
